import React, { useEffect, useState } from 'react';
import PlusSVG from 'Components/Admin/assets/PlusSVG';
import MinusSVG from 'Components/Admin/assets/MinusSVG';

const Range = ({ label, value = 0, name, onChange, maxHours = 24, minHours = 0 }) => {
  const handleIncrement = () => onChange({ [name]: Math.min(++value, maxHours) });
  const handleDecrement = () => onChange({ [name]: Math.max(--value, minHours) });

  const handleChange = (e) => {
    onChange({ [name]: Math.min(Math.max(+e.target.value, minHours), maxHours) });
  };

  return (
    <div className="schedule-field__range">
      <div className="schedule-field__label">{label}</div>
      <div className="schedule-field__input">
        <button
          className="schedule-field__btn"
          data-testid={`decrement-btn-${name}`}
          onClick={handleDecrement}
          disabled={value < minHours}
        >
          <MinusSVG />
        </button>
        <input className="schedule-field__value" value={value || 0} onChange={handleChange} data-testid={name} />
        <button
          className="schedule-field__btn schedule-field__btn_plus"
          data-testid={`increment-btn-${name}`}
          onClick={handleIncrement}
          disabled={value > maxHours}
        >
          <PlusSVG />
        </button>
      </div>
      <div className="schedule-field__unit">hours</div>
    </div>
  );
};

const Schedule = ({ fieldProps: { onChange, value }, days, maxHours, minHours }) => {
  const [state, setState] = useState({});

  useEffect(() => {
    const state = days.reduce((obj, day) => {
      if (day.name) obj[day.name] = (value && value[day.name]) || 0;

      return obj;
    }, {});

    setState(state);
  }, [days]);

  useEffect(() => {
    onChange(state);
  }, [state]);

  const handleChange = (state) => setState(prevState => ({ ...prevState, ...state }));

  return (
    <div className="schedule-field" data-testid="schedule-field">
      {
        days.map(({ name, label }) => (
          <Range
            label={label}
            key={name}
            value={state && state[name]}
            name={name}
            onChange={handleChange}
            maxHours={maxHours}
            minHours={minHours}
          />
        ))
      }
    </div>
  );
};

export default Schedule;
